import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    button: {
      backgroundColor: "#D93AD3",
      color: "#fff",
      borderRadius: "50%",
      width: 40,
      height: 40,
      minWidth: 0,
      padding: 0,
    },
    badge: (isRequired:boolean) => ({
      '& .MuiBadge-badge': {
        height: "20px",
        width: "20px",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        visibility: isRequired ? 'visible' : 'hidden',
        alignItems: "center",
        background: colors.color12,
        color: colors.color25,
        '& .MuiSvgIcon-root':{
          fontSize: '16px'
        } 
      },
    }),
  }

}